<template>
  <div>
    <el-select v-model="province" placeholder="请选择省">
      <el-option
        v-for="item in provinceData"
        :key="item.code"
        :label="item.name"
        :value="item.name">
      </el-option>
    </el-select>
    <el-select v-model="city" placeholder="请选择市" class="ml20" v-if="hasCity">
      <el-option
        v-for="item in cityData"
        :key="item.code"
        :label="item.name"
        :value="item.name">
      </el-option>
    </el-select>
    <el-select v-model="county" placeholder="请选择区" class="ml20" v-if="hasCity&&hasCounty">
      <el-option
        v-for="item in countyData"
        :key="item.code"
        :label="item.name"
        :value="item.name">
      </el-option>
    </el-select>
  </div>
</template>

<script>
var cityData = require('./citys.json')
export default {
  name: 'Province',
  props: {
    hasCity: {
      type: Boolean,
      default: false
    },
    hasCounty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provinceData: cityData,
      cityData: cityData[0].cityList,
      countyData: cityData[0].cityList[0].areaList,
      province: '',
      city: '',
      county: '',
    }
  },
  watch: {
    'province' (val, oldVal) {
      this.cityData = this.provinceData.filter(item  => item.name == val)[0] ? this.provinceData.filter(item  => item.name == val)[0].cityList : []
      if (this.cityData.length) {
        if (this.city && this.cityData.map(item => item.name).includes(this.city)) {
          this.countyData = this.cityData.filter(item  => item.name == val)[0] ? this.cityData.filter(item  => item.name == val)[0].areaList : []
        } else {
          this.city = this.cityData[0].name
        }
      }
    },
    'city' (val) {
      // console.log('city')
      this.countyData = this.cityData.filter(item  => item.name == val)[0] ? this.cityData.filter(item  => item.name == val)[0].areaList : []
      if (this.countyData.length) {
        
        if (this.county && this.countyData.map(item => item.name).includes(this.county)) {
          
        } else {
          this.county = this.countyData[0].name
        }
      }
    },
  }
}
</script>

<style>

</style>